import type { ConnectionMethod } from '@crowdex/plugin-contracts';
import { HubConnections } from './hub-connections';
import { needsNoAccount } from './plugin-agent-actions';

/**
 * How to connect one service, inside its plugin's page: the hub's accounts of the way of connecting
 * a tab is about (every way, without one), and the button that connects it.
 */
export function PluginServiceConnections({
  service,
  method,
}: {
  service: string;
  method?: ConnectionMethod;
}) {
  if (method !== undefined && needsNoAccount(method))
    return (
      <p className="text-muted-foreground text-xs" role="status">
        No account needed: agents use it as it is.
      </p>
    );
  return (
    <HubConnections service={service} {...(method === undefined ? {} : { method: method.id })} />
  );
}
